<template>
  <BlockFieldset class="project-employer-communication">
    <b-row>
      <b-col lg="6" md="6" sm="12">
        <div class="label">{{ $t('askEmployerCategoryState') }}</div>
        <div>
          <multiselect
            :placeholder="$t('askEmployerCategoryState')"
            v-model="project.askEmployerCategoryState"
            id="askEmployerCategoryState"
            :options="getEnumValues('AskEmployerCategoryState')"
            :allow-empty="true"
            :show-labels="false"
            :disabled="isBlockReadOnly"
            deselectLabel
          >
            <template slot="singleLabel" slot-scope="{ option }">
              <b-badge>
                {{ $t(option) }}
              </b-badge>
            </template>
            <template slot="option" slot-scope="{ option }">
              <b-badge>
                {{ $t(option) }}
              </b-badge>
            </template>
          </multiselect>
        </div>

        <div class="label">{{ $t('askEmployerNote') }}</div>
        <div class="dense-editor">
          <ckeditor
            :editor="editor"
            v-model="project.askEmployerNote"
            :config="editorConfig"
            :disabled="isBlockReadOnly"
          ></ckeditor>
        </div>
      </b-col>
      <b-col lg="6" md="6" sm="12">
        <div class="label">{{ $t('answerFromEmployerNote') }}</div>
        <div class="dense-editor">
          <ckeditor
            :editor="editor"
            v-model="project.answerFromEmployerNote"
            :config="editorConfig"
            :disabled="isBlockReadOnly"
          ></ckeditor>
        </div>
      </b-col>
    </b-row>

    <div v-if="hasSaveButton" class="text-right mt-2">
      <b-button variant="bg" :disabled="isSaving" @click="save">
        {{ $t('saveNamed', { name: $t('communication_with_employer') }) }}
      </b-button>
    </div>
  </BlockFieldset>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import InlineEditor from '@ckeditor/ckeditor5-build-inline';
import BlockFieldset from '@/components/Access/BlockFieldset.vue';
import { AccessBlockMixin } from '@/mixins/accessBlock';
import { BlockSaveMixin } from '@/mixins/blockSave';
import { toProjectEmployerCommunicationInput } from './projectEmployerCommunicationInput';

/** Number of the unsaved project (ProjectEdit `_new`): its values go with `createProject`. */
const NEW_PROJECT_NUMBER = '_new';

/**
 * Block project-employer-communication ("Kommunikation mit Auftraggeber", see feature page
 * projekt-kommunikation): ticket category, question to and answer from the employer, own save
 * button. On the unsaved project the fields go with `createProject`. Emits `dirty` and `saved`.
 */
export default {
  name: 'ProjectEmployerCommunication',
  components: { BlockFieldset, Multiselect, ckeditor: CKEditor.component },
  mixins: [AccessBlockMixin, BlockSaveMixin],
  props: {
    blockId: { type: String, required: true },
    project: { type: Object, required: true },
  },
  data() {
    return {
      editor: InlineEditor,
      editorConfig: {},
    };
  },
  computed: {
    ...mapGetters(['getEnumValues']),
    blockInput() {
      return toProjectEmployerCommunicationInput(this.project);
    },
    hasSaveButton() {
      return !this.isBlockReadOnly && this.project.number !== NEW_PROJECT_NUMBER;
    },
  },
  methods: {
    ...mapActions(['updateProjectEmployerCommunication']),
    saveBlockInput(input) {
      return this.updateProjectEmployerCommunication({ projectNumber: this.project.number, input });
    },
  },
};
</script>

<style scoped lang="scss">
.dense-editor {
  height: auto;
  max-height: 300px;
  overflow-y: auto;
}

.ck-editor__editable_inline {
  min-height: 110px;
  height: auto;
  max-height: 300px;
  overflow-y: auto;
}
</style>
